import styled, { css } from "styled-components";
import { device } from "@core-const";
import { AdminNavigationListStyledProps, MyProfileNavigationListStyledProps } from "@core-interface";
import { FlexRow, FlexCenter, FlexCol } from "app-styled/flex";
import { LinkButtonSmall } from "app-styled/link";
import { Col, Row } from "reactstrap";
import { ItemTitle } from "../services/services.styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const AdminNavigatorContainer = styled(FlexRow)`
  margin-top: 1px;
  height: calc(100vh - 81px);
  ${({ theme }) => css`
    @media${theme.tablet} {
      width: auto;
    }
  `}
`;

export const AdminNavigationList = styled.div`
  padding: 0;
  width: 100%;

  ${({ theme }) => css`
    /* background-color: ${theme["smylor-blue-darken-D"]}; */
    @media ${device.tabletL} {
    .k-drawer {
        position: absolute;
        left: -100%;
      }
      &.show {
        .k-drawer {
          animation-duration: 4s;
          position: absolute;
          width: 320px;
          height: 100%;
          left: 0px;
          z-index: 2;
          .k-drawer-wrapper {
            animation-duration: 4s;
            width: 100% !important;
          }
          .nav-item-logout-icon {
            margin-left: auto;
          }
        }
      }
    }

    .k-drawer-container {
      height: calc(100vh - 81px);
      .k-drawer-items {
        margin-top: ${theme["thm-space-lg"]};
        height: calc(100% - ${theme["thm-space-lg"]});
      }
      .k-drawer-content {
        overflow-y: auto;
      }
    }

    // mini view need styles
    /* .k-drawer-start{
      flex-basis: 94px !important;
      .nav-item-text{
        display: none;
      }
      .nav-item-container{
        width: 48px;
        padding: ${theme["thm-space-rg"]};
        align-items: center;
        justify-content: center;
      }
      .nav-item-logout-container{
        width: 48px;
        padding: ${theme["thm-space-sm"]};
        align-items: center;
        justify-content: center;
      }
      .nav-item-logout-icon{
          width: 35px;
          height: 35px;
          border-radius: 50%;
      }
    } */
    .k-drawer-wrapper {
      height: 100%;
    }

    .k-drawer-start {
      flex-basis: unset !important;
      .nav-item-text {
        display: flex;
      }
      .nav-item-container {
        width: 100%;
        justify-content: flex-start;
      }
      .nav-item-logout-container {
        width: 100%;
        justify-content: flex-start;
        padding: 20px;
      }
      .nav-item-logout-icon {
        width: 50px;
        height: 50px;
      }
    }
  `}
`;

export const AdminNavigatorListItem = styled.div<AdminNavigationListStyledProps>`
  font-weight: 500 !important;
  text-align: left;
  ${({ theme }) => css`
    padding: ${theme["padding-dropMenu"]} 20px;
    border-bottom: 1px solid ${theme["smylor-blue-darken-D"]};
    background-color: ${theme["smylor-blue-darken-D"]};
    color: #ffffff;
    &:hover {
      background-color: ${theme["smylor-light-blueA"]};
      cursor: pointer;
      color: #000000;
    }
  `}
  ${({ theme, selected }) =>
    selected &&
    css`
      color: ${theme.colorBtnText};
      background-color: ${theme["smylor-light-blueA"]};
    `}
`;

export const LoadingWrapper = styled(FlexCenter)`
  ${({ theme }) =>
    css`
      font-size: ${theme["fontSize-elementSmall"]};
      color: ${theme["color-dark"]};
      margin: ${theme["thm-space-xl"]};
      font-family: ${theme["fontFamily-regular"]};
    `}
`;

export const ReviewCardWrapper = styled.div`
  ${({ theme }) =>
    css`
      margin-top: ${theme["thm-space-xl"]};
    `}
`;

export const ReviewButtonContainer = styled(FlexRow)`
  justify-content: end;
`;

export const ReviewButton = styled(LinkButtonSmall)`
  margin-right: 0;
  ${({ theme }) => css`
    padding: ${theme["thm-space-sm"]} ${theme["thm-space-xl"]};
  `}
`;

export const ItemInner = styled(Row)`
  position: relative;
  &:hover {
    cursor: pointer;
  }
`;

export const InfoContainer = styled(Col)``;

export const DescriptionContainer = styled(Col)`
  font-style: italic;
  overflow: hidden;
  font-size: 14px;
  h3 {
    font-style: initial;
  }
`;

export const DescriptionReviewContainer = styled(DescriptionContainer)`
  padding-right: 55px;
`;

export const IconContainer = styled.div`
  position: absolute;
`;

export const SearchBoxContainer = styled(FlexRow)`
  margin-left: auto;
  ${({ theme }) => css`
  margin-right: -${theme["thm-space-md"]};
  `}
`;

// new styles

export const NavigatorListItemConatainer = styled(FlexRow)`
  ${({ theme }) => css`
    margin-bottom: ${theme["thm-space-md"]};
    padding-left: ${theme["thm-space-xl"]};
    padding-right: ${theme["thm-space-xl"]};
    
    @media ${device.tabletL} {
      padding-left: ${theme["thm-space-rg"]};
      padding-right: ${theme["thm-space-rg"]};
    }
  `}
  &.nav-item-logout {
    margin-top: auto;
    margin-bottom: 0;
  }
`;

export const ListItemLogoutContainer = styled(FlexRow)`
  width: 100%;
  align-items: center;

  ${({ theme }) => css`
    gap: ${theme["thm-space-rg"]};
    margin-top: ${theme["thm-space-xl"]};
    margin-bottom: ${theme["thm-space-lg"]};
    padding: 20px;
    background-color: ${theme["smylor-light-blueD"]};
    border-radius: ${theme["thm-space-md"]};

    .k-avatar-solid-primary {
      background-color: ${theme["smylor-white"]};
    }
  `}
`;

export const ListItemLogoutProfilewrapper = styled(FlexCol)`
  flex-grow: 1;
  max-width: 124px;
  overflow: hidden;
`;

export const LogoutNameContainer = styled(ItemTitle)`
  margin-bottom: 0px;
`;

export const ListItemLogoutIconContainer = styled(FlexCenter)`
  cursor: pointer;
  ${({ theme }) => css`
    :hover {
      background-color: ${theme["smylor-light-blueA"]};
      background-size: 50px;
      border-radius: 50%;
    }
  `}
`;

export const ListItemIcon = styled(FontAwesomeIcon)`
  width: 30px;
`;

export const MyProfileNavigatorListItem = styled.div<MyProfileNavigationListStyledProps>`
  font-weight: 500 !important;
  text-align: left;
  width: 100%;
  display: flex;
  ${({ theme }) => css`
    padding: ${theme["padding-dropMenu"]} 20px;
    gap: ${theme["thm-space-lg"]};
    color: ${theme["smylor-blue-darken-A"]};
    border-radius: ${theme["thm-space-md"]};
    &:hover {
      background-color: ${theme["smylor-pink-D"]};
      cursor: pointer;
      color: #000000;
    }
  `}
  ${({ theme, selected }) =>
    selected &&
    css`
      color: ${theme["smylor-white"]};
      /* background-color: ${theme["smylor-blue"]}; */
      background-color: ${theme["smylor-blue-light"]};
      &:hover {
        /* background-color: ${theme["smylor-blue"]}; */
        background-color: ${theme["smylor-blue-light"]};
        color: ${theme["smylor-white"]};
      }
    `}
`;

export const ReviewCommonBody = styled(FlexCol)`
    ${({ theme }) => css`
      gap: 48px;
      @media ${device.tabletL} {
        gap: ${theme["thm-space-xl"]};
      }
    `}

`;
